<template>
 
  <div class="container-fluid maineditor p-0" style="height:100%; min-height:300px">
    <div class="row" style="height: 100%; min-height: 300px">
      <div class="col" style="height: 100%; min-height: 300px">
        <editor ref="editor" api-key="ean2nl7prjqb1unjkg6kltidatbm2xw31kalfemhvh3vw07n"
                :plugins="plugins"
                :toolbar="toolbar"
                :init="myInit"
                :readonly="disabled"
                :disabled="disabled"
                v-model="modelValue"
                @input="$emit('change', modelValue)" />
      </div>
    </div>
    <upload-container ref="uploadComponent" @change="selectedFromCustomFileSelector"></upload-container>
  </div>
</template>



<script>

  import Editor from '@tinymce/tinymce-vue'
  import UploadContainer from "../upload/upload-container.vue";

  export default {

    name: 'new-mce-editor',
    components: {
      'editor': Editor,
      UploadContainer
    },
    methods: {
      //updateInput() {
      //  this.$emit('input', this.content)
      //}
      selectedFromCustomFileSelector(val, name, settings) {
        
        this.fileSelectionSuccessFunction(val, { alt: name });
      }
    },
    model: {
      prop: 'modelValue',
      event: 'change'
    },
    props: {
      title: String,
      disabled: {
        type: Boolean,
        default: false
      },
      method: { type: Function },
      filefolder: { type: String, default: null },
      content: { type: String, default: "" },
      modelValue:{ type: String, default: "" },
    },
    data() {
      return {
        toolbar: "bold italic underline link image media code | bullist numlist myCustomToolbarButton",
        plugins: "link image imagetools media code lists",
        myInit: null,
        fileSelectionSuccessFunction: null,
      };
    },
    watch: {

    },
    mounted() {
      var thisContext = this;

      this.myInit = {

        setup: editor => {
          // use this to add a custom button, 'myCustomToolbarButton' has to be in the toolbar for it to be visible
          //editor.ui.registry.addButton('myCustomToolbarButton', {
          //  text: 'My Custom Button',
          //  onAction: () => alert('Button clicked!')
          //});
        },
        menubar: false,
        extended_valid_elements: 'i[class],em[class]',
        content_css: '/global_assets/css/icons/icomoon/styles.css,/global_assets/css/icons/fontawesome/styles.min.css,/assets/css/bootstrap.min.css,/assets/css/bootstrap_limitless.min.css,/assets/css/layout.min.css,/assets/css/components.min.css,/assets/css/colors.min.css,/global_assets/css/custom-style.css,/global_assets/css/custom-media.css,/css/custom-colors.css,/css/Themes.css',

        images_dataimg_filter: function (img) {
          return false;
          return img.hasAttribute('internal-blob');
        },
        keep_styles: false,
        convert_urls: false,
        height: this.height,
        automatic_uploads: true,
        images_upload_base_path: Vue.prototype.$hostname + "/api/upload/v1/upload",
        relative_urls: false,
        content_style: ".mce-content-body {padding-left: 5px; padding-right: 5px }",

        // override default upload handler to simulate successful upload
        images_upload_handler: function (blobInfo, success, failure, folderName) {
          var xhr, formData;
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;

          xhr.open('POST', Vue.prototype.$hostname + "/api/upload/v1/upload?filefolder=" + thisContext.filefolder);

          //xhr.setRequestHeader("X-CSRF-Token", token);

          xhr.onload = function () {
            var json;

            if (xhr.status != 200) {
              failure('HTTP Error: ' + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);

            if (!json || typeof json.url != 'string') {
              failure('Invalid JSON: ' + xhr.responseText);
              return;
            }
            success(json.url);

          };

          formData = new FormData();
          formData.append('file', blobInfo.blob(), blobInfo.filename());

          xhr.send(formData);

        },
        file_picker_callback: function (success, value, meta) {

          var fileBrowseUrl = "/pickfile.html"; //external page
          thisContext.$refs.uploadComponent.open();
          thisContext.fileSelectionSuccessFunction = success;
          /*
          tinyMCE.activeEditor.windowManager.openUrl({
            url: fileBrowseUrl,
            title: 'Server File Browser',
            width: 800,
            height: 600,
            resizable: "yes",
            onMessage: function (api, data) {
              success(data.src, { alt: data.alt });
            }
          });
          */

          return;

          var input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');

          /*
            Note: In modern browsers input[type="file"] is functional without
            even adding it to the DOM, but that might not be the case in some older
            or quirky browsers like IE, so you might want to add it to the DOM
            just in case, and visually hide it. And do not forget do remove it
            once you do not need it anymore.
          */

          input.onchange = function () {

            var file = this.files[0];

            var reader = new FileReader();

            reader.onload = function () {
              var id = 'blobid' + (new Date()).getTime();
              var blobCache = tinymce.activeEditor.editorUpload.blobCache;
              var base64 = reader.result.split(',')[1];
              var blobInfo = blobCache.create(id, file, base64);
              blobCache.add(blobInfo);

              //We have read the file as a, now try to upload it

              var xhr, formData;
              xhr = new XMLHttpRequest();
              xhr.withCredentials = false;

              xhr.open('POST', Vue.prototype.$hostname + "/api/upload/v1/upload?filefolder=" + thisContext.filefolder);

              formData = new FormData();
              formData.append('file', blobInfo.blob(), blobInfo.filename());

              xhr.onload = function () {
                var json;

                if (xhr.status != 200) {
                  failure('HTTP Error: ' + xhr.status);
                  return;
                }
                json = JSON.parse(xhr.responseText);

                if (!json || typeof json.url != 'string') {
                  failure('Invalid JSON: ' + xhr.responseText);
                  return;
                }
                success(json.url);

              };

              xhr.send(formData);

            };

            reader.readAsDataURL(file);

          };

          input.click();

          /*
          // Provide file and text for the link dialog
          if (meta.filetype == 'file') {
            callback('mypage.html', { text: 'My text' });
          }

          // Provide image and alt text for the image dialog
          if (meta.filetype == 'image') {
            callback('myimage.jpg', { alt: 'My alt text' });
          }

          // Provide alternative source and posted for the media dialog
          if (meta.filetype == 'media') {
            callback('movie.mp4', { source2: 'alt.ogg', poster: 'image.jpg' });
          }
          */
         

         
        }
      }

      
    },
  }
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .editorwrapper {
    height: 100%;
  }
</style>
<style>
  .tox-tinymce {
    height: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/mce/new-mce-editor.vue